export const getBookingLeadDays = (settings = {}) => (
  Number.isSafeInteger(settings.bookingLeadDays) && settings.bookingLeadDays >= 0
    ? settings.bookingLeadDays
    : (settings.sameDayAppointment === true ? 0 : 1)
);

// An empty input must not silently become zero (same-day booking).
export const parseBookingLeadDays = value => {
  if (!/^\d+$/.test(String(value))) return null;
  const days = Number(value);
  return Number.isSafeInteger(days) && days >= 0 ? days : null;
};
